module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Among the Fair Magnolias: Four Southern Love Stories")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "sec-13"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "AszW"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/img-7-1.jpg",
      "src": "images/img-7-1.jpg"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#toc2",
      "id": "con2"
    }
  }, [_vm._v("CHAPTER ONE")]), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/img-7-2.jpg",
      "src": "images/img-7-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txc1",
    attrs: {
      "id": "pz13-4"
    }
  }, [_c('i', [_vm._v("Pawleys Island, South Carolina")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("May 1860")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz13-6"
    }
  }, [_vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNETT TRULY FORGIVEN HER")]), _vm._v("? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-7"
    }
  }, [_vm._v(" Skirts tucked up, shoes dangling from one hand, Abigail Clayton stepped over the pungent remains of a horseshoe crab and studied the tumbling surf as if the answer to her question might be written there. A storm had blown ashore after midnight, leaving in its wake piles of broken shells, burrowing whelks, and clumps of rust-colored seaweed. Under the warm spring light the deserted beach took on a particular radiance that illuminated a pair of orange-beaked skimmers searching for sand crabs and a flock of brown pelicans gliding above the breakers. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-8"
    }
  }, [_vm._v(" Despite her worry, Abby released a grateful sigh. How perfect was God’s creation, how delightful the rhythm of life on Pawleys Island. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-9"
    }
  }, [_vm._v(" Last week, with the last of the rice fields planted, Papa had closed Mulberry Hall and moved the household—furnishings, livestock, house servants, and all—here. To Osprey Cottage. The twelve-mile journey—nine by water down the Waccamaw River and three by land—had been accomplished by nightfall. The days following passed "), _c('span', {
    attrs: {
      "id": "z14-5"
    }
  }, [_vm._v("in a blur of activity. After a thorough cleaning and airing of the cottage, Mama had supervised the unpacking of dishes and lamps, silver and crystal, and set about preparing for the Claytons’ annual spring barbecue. On Friday the beach would ring with the sound of dozens of their guests gathering for a three-day visit before leaving for summer homes in Saratoga or Europe. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-6"
    }
  }, [_vm._v(" Abby dropped her shoes onto the sand and stooped to examine a tiny fan-shaped shell. Mama was counting on her to help with the preparations, but all she could think about was Dr. Wade Bennett. Would he attend the party or stay away? Was he still holding on to his anger in the wake of their quarrel? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-7"
    }
  }, [_vm._v(" She heaved another sigh. If only she could take back her hurtful words. If only she could tell him that— ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-8"
    }
  }, [_vm._v(" “Miss Abigail!” Rapid footsteps sounded behind her, and Abby turned to see her mother’s favorite house servant, Sophronia, hurrying along the beach. Sturdy and compact, Sophronia reminded Abby of the steamers that plied the Lowcountry rivers. All she lacked was a smokestack and a whistle. And despite her small stature, she could move like wildfire through kindling when on a mission from Mama. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-9"
    }
  }, [_vm._v(" Clearly that was the case now. Sophronia hove to a stop in front of Abby, hands on hips, a frown creasing her smooth brown face. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-10"
    }
  }, [_vm._v(" “Where you been? Your mama sent me to fetch you half an hour ago.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-11"
    }
  }, [_vm._v(" “I went down to the boathouse.” Abby jumped as the cold surf rushed over her bare toes. “I wanted to be sure my rowboat survived the winter. I must have lost track of time.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-12"
    }
  }, [_vm._v(" “Humph. You know Miss Alicia don’t like you taking that boat out by yourself. It sure ain’t ladylike, and ’sides that, it ain’t safe.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz14-13"
    }
  }, [_vm._v(" “I’ve had a boat since I was ten years old. And I don’t take it into open water. I stick to the marshes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-5"
    }
  }, [_vm._v(" “Where the alligators just waitin’ to gobble you up for breakfast.” Sophronia glanced at Abby’s feet. “Better not let Miss Alicia catch you running ’round with no shoes on.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-6"
    }
  }, [_vm._v(" “I know it. Mama can be such a stickler for propriety.” Abby plopped down on a patch of dry sand to pull on her stockings and shoes. “Honestly, I don’t see why she must stand on formality even here at the beach.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-7"
    }
  }, [_vm._v(" Sophronia’s brows went up. “Maybe ’cause your daddy got his sights on running for office, and the governor hisself is on the way here for the barbecue.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-8"
    }
  }, [_vm._v(" Sophronia held out a hand and hauled Abigail to her feet. “Come on home now ’fore your breakfast gets cold as stone.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-9"
    }
  }, [_vm._v(" Abby followed Sophronia up the path to the cottage that had been her summer home for her entire life. Constructed of plain clapboards, it was not quite as large as the summer homes of their neighbors, the Westons, the Frasers, and the Allstons, but it boasted a prime location on the four-mile-long spit of land that was Pawleys. A wraparound porch provided a shady spot to while away a summer afternoon, watching the seabirds and the occasional pod of dolphins. The rear of the house faced the golden marshes and the endless serpentine creeks that fed into the broad, blue Waccamaw River. A sight that never failed to soothe her spirit. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-10"
    }
  }, [_vm._v(" “There you are.” Mama stood on the porch, leaning on her walking cane, watching Abby’s approach. Her voice was stern, but her brown eyes held a hint of merriment. “I might have known you’d come home damp and sandy. Don’t track that dirt into the parlor, please, Abigail. Your father is expecting Governor Gist this afternoon, and Molly has already cleaned it. And for heaven’s sake, do something with your hair. It looks like a rat’s nest.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz15-11"
    }
  }, [_vm._v(" “Yes, Mama.” Abby ran lightly up the steps and planted a kiss on "), _c('span', {
    attrs: {
      "id": "z16-5"
    }
  }, [_vm._v("her mother’s cheek. “I’m sorry you had to send out a search party. I didn’t intend to be gone for so long.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-6"
    }
  }, [_vm._v(" “You’re here now, and no harm done. Your breakfast is waiting in the dining room. Please tidy up and meet me there. We have a million things to do before Saturday.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-7"
    }
  }, [_vm._v(" Ten minutes later Abby was seated in the dining room, a plate of eggs, sausage, and Molly’s delicious spoon bread in front of her. Molly bustled in and poured coffee into Abby’s paper-thin china cup. She set down a cut-glass pitcher of warm syrup. “Here you are, missy. Molly knows you partial to havin’ syrup with spoon bread.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-8"
    }
  }, [_vm._v(" Abby drizzled syrup over the bread and took a bite. “Delicious, Molly. Don’t I always say you make the best spoon bread in the Carolinas?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-9"
    }
  }, [_vm._v(" With a gentle nod Mama dismissed Molly. She opened a leather-bound book and picked up her pencil. “Our dresses have arrived. You must try yours on at once in case it needs any last-minute alterations.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-10"
    }
  }, [_vm._v(" “All right.” Abby took another bite of spoon bread, letting the warm sweetness linger on her tongue. She peered at the stack of mail on the table. “More replies for the barbecue?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-11"
    }
  }, [_vm._v(" “Yes. These came yesterday, but I was too busy to open them.” Mama withdrew a sheet of paper from a thick envelope. “The Frasers are coming. Poor Francis. I feel so sorry for him, trying to raise Charlotte all alone. You must remember to make time for her, Abigail. She’s much younger than you, but desperately in need of female friendships.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz16-12"
    }
  }, [_vm._v(" Abby dug into her eggs. Fairhaven, the Frasers’ plantation, was their neighbor on the Waccamaw. On her visits home from boarding school, she’d caught occasional glimpses of a small, sturdy girl traipsing after her father in the rice fields, her dark hair flying, her too-large boots sinking into the marshy ground. Abby couldn’t help envying the younger girl’s relationship with her father. Mr. Fraser seemed to "), _c('span', {
    attrs: {
      "id": "z17-5"
    }
  }, [_vm._v("dote on his only child, whereas Abby’s own father believed girls were meant to be seen and not heard. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-6"
    }
  }, [_vm._v(" “The Averys are coming up from Georgetown tomorrow,” Mama continued. “Theodosia will room with you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-7"
    }
  }, [_vm._v(" “Oh. I was hoping to see more of Penny Ravensdale. It’s been ages since we last spoke.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-8"
    }
  }, [_vm._v(" Mama scribbled in her notebook and spoke without looking up. “You’ll see plenty of Penelope. The Ravensdales will be staying here for the weekend. Besides, Theodosia is perfectly lovely. And so ladylike.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-9"
    }
  }, [_vm._v(" “And I’m not?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-10"
    }
  }, [_vm._v(" “I didn’t say that, darling. Only you must try to comport yourself with great care this weekend. For your father’s sake.” Mama’s brown eyes bore into Abby’s. “You know how strong his political aspirations are. We owe it to him to do all we can to make a favorable impression on Governor Gist. The governor’s opinion will carry a great deal of weight when the state legislature meets to choose his successor.” Mama reached across the table and cupped Abby’s chin in her hand. “Whatever your opinions, please try not to voice them.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-11"
    }
  }, [_vm._v(" “After all the money Papa has spent filling my head with knowledge, I don’t see why now I’m obliged to conceal it, but all right.” Abby raised one hand, palm out, as if taking an oath. “I will be the walking definition of ‘seen and not heard.’ ” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-12"
    }
  }, [_vm._v(" Mama tried and failed to suppress a smile. “Thank you. Will you please see that Sophronia makes room in your clothespress for Theodosia’s things?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-13"
    }
  }, [_vm._v(" “Fine. But my room is so small we’ll be tripping over each other all weekend.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz17-14"
    }
  }, [_vm._v(" “I know it. Osprey Cottage will be full to the rafters when everyone gets here. But it’s only for a few days. The Averys are sailing for New York a week from Thursday, and after this weekend the "), _c('span', {
    attrs: {
      "id": "z18-5"
    }
  }, [_vm._v("Ravensdales will be staying at the Wards’ cottage. Emily and John have already left for the Continent.” Mama flipped a page and consulted her list. “Seventy-five people coming, so far.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-6"
    }
  }, [_vm._v(" “Heavens. They’ll overrun this poor little island.” Abby tried to lighten her tone, but she was desperate for news of one certain invitation Mama hadn’t yet mentioned. “Any word from the Bennetts?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-7"
    }
  }, [_vm._v(" “Nothing so far, but I’m sure Dr. Bennett and his parents will attend, just as they always have. Judge Bennett is not one to miss a chance to go fishing with your father.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-8"
    }
  }, [_vm._v(" Memories of her last evening with Wade Bennett set Abby’s insides to churning. Three months apart had made her realize just how deeply she cared for him. How fervently she hoped he felt the same way about her. Last Christmas she’d thought he was ready to propose, but the holidays had come and gone without any declaration on his part. Then in February had come the unsettling quarrel that still brought tears to her eyes if she thought too long about it. What if they could never recapture the mutual delight and perfect harmony they’d once enjoyed? What if she couldn’t convince him of her change of heart? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-9"
    }
  }, [_vm._v(" Mama smiled and patted Abby’s hand. “You mustn’t fret, darling. Whatever your disagreement, it can’t be all that serious.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-10"
    }
  }, [_vm._v(" But it was. They had discovered a deep and fundamental difference in what they expected from life. As dearly as she loved him, as ready as she was to admit to her faults and seek a compromise, she had wondered and worried all spring about whether things between them could ever be put to rights. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz18-11"
    }
  }, [_vm._v(" Mama opened another envelope and drew out a single sheet of ivory vellum covered in small script. “Here’s a note from Celia Mackay in Savannah. She says that she and Sutton can’t join us this time. She’s going to become a mother this autumn.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-5"
    }
  }, [_vm._v(" Abby noted the tears in her mother’s eyes. “But that’s happy news, isn’t it?” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-6"
    }
  }, [_vm._v(" “I’m delighted for Celia and Sutton, but terribly sad that her father won’t ever know his grandchild. David Browning was the most devoted father I’ve ever known. Apart from your own father, of course.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-7"
    }
  }, [_vm._v(" Abby took another bite of spoon bread. She didn’t doubt her father’s affection, even if he didn’t often show it. She loved him too. Respected him. But a part of her feared him. Not so with her mother, who was the very soul of parental tenderness. For all of her life, Mama had been the one to indulge her only daughter’s passions, to encourage her in her various pursuits. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-8"
    }
  }, [_vm._v(" Seeing her mother’s sadness, Abby felt an overwhelming rush of love. A riding accident at age twelve had left Mama with a severe limp that required the use of a walking cane. But she hadn’t allowed her infirmity to sour her disposition, to weaken her faith in a merciful God, or to dampen her enthusiasm for life. Even though Abby was a grown woman now, it was still her greatest joy and pride to win her mother’s approval, and her praise meant more than that of anyone else. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-9"
    }
  }, [_vm._v(" On a long breath, Mama set aside Mrs. Mackay’s letter and opened the next one. “Ophelia Kittridge is coming. And Charles is attending as well.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz19-10"
    }
  }, [_vm._v(" Abby’s cup banged into the saucer with more force than she intended. Her appetite fled at the recollection of her unpleasant encounter with Charles Kittridge last summer. She hadn’t told anybody what happened—not even Penny, who was her closest friend this side of heaven. It had been too upsetting. Even now the memory of it made her feel ashamed. As though the entire disgusting episode had been her fault. She pushed her plate away. “Oh mercy. What an insufferable pest Charles is, and his mother is the worst gossip in the entire Lowcountry. I don’t see why—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-5"
    }
  }, [_vm._v(" “They’re your father’s cousins.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-6"
    }
  }, [_vm._v(" “Yes, but such distant cousins they hardly count as kin at all.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-7"
    }
  }, [_vm._v(" “Nevertheless, we can’t very well exclude them. Your father still has hopes that you and Charles might one day—” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-8"
    }
  }, [_vm._v(" “I know what he wants, but I wouldn’t marry Charles Kittridge if he were the last man breathing.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-9"
    }
  }, [_vm._v(" Through the window Abby watched the brown pelicans diving into the surf. She would have to at least greet the odious Charles. She might even be forced to dance with him. But the only guest she was interested in seeing was Dr. Wade Bennett. And so far, he was silent. ")]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    attrs: {
      "alt": "images/image1.jpg",
      "src": "images/image1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz20-10"
    }
  }, [_vm._v(" Standing in the middle of her bedroom, clad in her chemise and petticoats, Abby lifted her arms as Sophronia slid the ocean-blue silk dress over her head. The voluminous skirt settled over her crinoline hoops, rustling as the maid did up the dozen tiny buttons in the back. Abby tugged at the scooped neckline to show off a bit more of her shoulders. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-11"
    }
  }, [_vm._v(" Sophronia frowned and rearranged it to her own satisfaction. “Now. That looks more like the lady you s’posed to be.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-12"
    }
  }, [_vm._v(" “Oh, for goodness’ sake.” Abby scowled. “This is 1860. And I’m twenty-three, not forty.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-13"
    }
  }, [_vm._v(" “Don’t make no difference. Ladylike is ladylike.” Sophronia opened a box and drew out a pair of kid pumps. “Try these slippers on your feet. I hope the heel is high enough so’s I don’t have to take up the hem of that gown. I got plenty more to do ’fore Saturday gets here.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz20-14"
    }
  }, [_vm._v(" Abby slid her feet into the shoes, not bothering to do up the buttons, and clumped over to the big cheval glass in the corner. She twirled around, the skirt belling about her ankles. This was not the gown "), _c('span', {
    attrs: {
      "id": "z21-5"
    }
  }, [_vm._v("she’d wanted. She had hoped for something more sophisticated. But Mama had enlisted the modiste, Mrs. Finley, in her cause, and Abby had finally given in. Now she had to admit her mother was right. The cut of the bodice flattered her small waist. The shimmering blue silk showed off her glossy brown hair and brought out the faint blush in her cheeks. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-6"
    }
  }, [_vm._v(" Even Sophronia, who rarely smiled, beamed when Abby turned to study the back of the gown in the glass. “You sure is a vision, Miss Abigail, and that’s the truth. Won’t be no empty spaces on your dance card.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-7"
    }
  }, [_vm._v(" Abby kicked off the shoes, which were already beginning to pinch her feet. “We won’t have dance cards. Despite the fancy clothes, the dance is informal—though you wouldn’t know it, the way Papa is carrying on.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-8"
    }
  }, [_vm._v(" “He wants to be gov’nor real bad, I reckon. Got to impress the muckety-mucks so’s they’ll vote him in come wintertime.” Sophronia retrieved the kid shoes and returned them to the box. “He sure is excited that the governor hisself accepted his invitation.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-9"
    }
  }, [_vm._v(" “He was on pins and needles for an entire week, waiting for Governor Gist to reply.” Abby’s face clouded. “I’ve hardly seen anything of Papa all spring.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-10"
    }
  }, [_vm._v(" Turning her back to Sophronia, she motioned for the maid to begin undoing the buttons. “Though these days Papa’s no fun at all anyway. It’s as if he’s forgotten how to talk about anything except politics. Secession this and secession that. It gives me a headache.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-11"
    }
  }, [_vm._v(" Sophronia chuckled. “I don’t understand politics neither.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz21-12"
    }
  }, [_vm._v(" “Oh, I understand it. But since the men are the only ones who can vote and will do as they wish regardless of what the women think, any discussion of it seems entirely pointless.” Abby stepped out of the blue gown and reached for her simple green day dress. She slipped it "), _c('span', {
    attrs: {
      "id": "z22-3"
    }
  }, [_vm._v("on and adjusted the matching satin sash. “I do miss taking the boat out with Papa.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz22-4"
    }
  }, [_vm._v(" “The summer just beginnin’ though. You and your daddy’ll have plenty o’ time once this weekend is over.” Sophronia carefully folded the dress and returned it to its muslin nest. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz22-5"
    }
  }, [_vm._v(" Outside, a horse and rig clopped along the beach road. Abby parted the curtain and looked out. A tall, broad-shouldered man with dark curly hair got out and brushed the dust from his gray jacket and trousers. He glanced up at her window as if he expected to find her waiting there. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz22-6"
    }
  }, [_vm._v(" Abby’s breath caught, and her heart expanded with sudden joy. After three long months, Wade Bennett had come home. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8ec1e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 72
// module chunks = 0